import React, { Fragment } from 'react'
import GatsbyImage from 'gatsby-image'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { tablet, mobile } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import SectionHead from '@/components/app/SectionHead'
import Details from './Details'

const Template = props => {
  const { ...others } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        return (
          <Root {...others}>
            <Container>
              <Head
                sub="CASE"
                main={(
                  <Fragment><strong>事例</strong>紹介</Fragment>
                )}
                lead={(
                  <Head_Lead>創業1901年の老舗お茶屋のリブランディング及び、<br />EC事業の全面的サポート</Head_Lead>
                )}
              />
              <Image fluid={data.image.childImageSharp.fluid} alt="Shopify ECサイト構築 事例" />
              <Details
                title="お茶の井上園"
                link="https://ocha-inoueen.jp/"
                tags={['ECサイト構築', '写真撮影', 'ライティング・記事作成', 'アクセス解析', '広告運用']}
                body={(
                  <Fragment>地域密着型のビジネスからECへの業態転換を総合的に支援。店舗に何度も足を運び、経営陣・スタッフへのインタビューや商品の試飲を重ね、ブランドストーリーや商品情報を依頼主様と一緒になって作り上げました。また、データに基づいた堅実なマーケティングを行えるようにアクセス解析設定も対応。ECビジネスを本格運用していくための土台を構築しました。</Fragment>
                )}
              />
            </Container>
          </Root>
        )
      }}
    />
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  background-color: ${props => props.theme.gray.b};
  padding: ${rem(56)} ${rem(layouts.defs.pad.base)};
  @media ${mq.and(tablet)} {
    padding: ${rem(60)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.mobile)} ${rem(56)};
  }
`

const Head = styled(SectionHead)``

const Head_Lead = styled.div`
  @media ${mq.and(mobile)} {
    br {
      display: none;
    }
  }
`

const Container = styled.div`
  margin: 0 auto;
`

const Image = styled(GatsbyImage)`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(24)};
  width: 100%;
  @media ${mq.and(mobile)} {
    margin-top: ${rem(24)};
  }
`

export const query = graphql`
  query CaseSectionQuery {
    image: file(relativePath: { eq: "case.png" }) {
      childImageSharp {
        fluid(maxWidth: 1960, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`
